module.exports = ".conditions-table {\n  width: 100%; }\n  .conditions-table th, .conditions-table td {\n    padding: 6px 8px;\n    vertical-align: middle; }\n  .conditions-table td.actions-col {\n    white-space: nowrap;\n    width: 1%; }\n  .no-conditions {\n  color: #999;\n  font-style: italic;\n  margin: 8px 0 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/registration-form/edit-registration-field-conditions/edit-registration-field-conditions.component.scss
// module id = ./src/app/modules/sessions/registration-form/edit-registration-field-conditions/edit-registration-field-conditions.component.scss
// module chunks = main